// This week's cover is a fully-designed magazine cover (built offline, XXL/VIBE-style).
// Swap the image below each week; set to null to fall back to the issue's lead review artwork.
const THIS_WEEK = {
  artist: "K. MICHELLE",
  image_url: "/images/kmichelle-xxl-cover-v1.jpg",
};

export const CoverStar = ({ lead }) => {
  const star = THIS_WEEK || lead;
  if (!star) return null;
  return (
    <a
      href="#cover-story"
      data-testid="rhythm-cover-star"
      aria-label={`${star.artist} — read the cover story`}
      className="group relative block overflow-hidden border-2 border-[#F3F1ED]"
    >
      <img
        src={star.image_url || star.artwork_url}
        alt={`${star.artist} — The Rhythm Report, Issue 03`}
        className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-[1.015]"
      />
    </a>
  );
};

export default CoverStar;
